export default {
  actions: {
    createRequirementGroup({ dispatch }, requirementGroup) {
      this.$authorize('edit', 'Opportunity')

      return Vue.$http
        .post(
          `admin/opportunities/${
            requirementGroup.opportunity.id
          }/requirement_groups`,
          { requirementGroup }
        )
        .then(() => dispatch('fetch', requirementGroup.opportunity.id))
    },
    updateRequirementGroup({ dispatch, commit }, requirementGroup) {
      this.$authorize('edit', 'Opportunity')

      return Vue.$http
        .patch(
          `admin/opportunities/${
            requirementGroup.opportunity.id
          }/requirement_groups/${requirementGroup.id}`,
          { requirementGroup }
        )
        .then(({ data: opportunity }) => {
          commit('admin/opportunities/set', opportunity, { root: true })
        })
    },
    removeRequirementGroup({ dispatch }, requirementGroup) {
      this.$authorize('edit', 'Opportunity')

      return Vue.$http
        .delete(
          `admin/opportunities/${
            requirementGroup.opportunity.id
          }/requirement_groups/${requirementGroup.id}`
        )
        .then(() => dispatch('fetch', requirementGroup.opportunity.id))
    }
  }
}
